import { Component, OnInit } from '@angular/core';
import {AppComponent} from '../../app.component';


@Component({
  selector: 'app-contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.css']
})
export class ContactInfoComponent implements OnInit {
  phoneApp: boolean = false;
  ipadApp: boolean = false;
  constructor(public myApp:AppComponent) {

  }
  ngOnInit() {
    if (window.innerWidth > 750 && window.innerWidth <1150){
      this.ipadApp = true;
    }
    if (window.innerWidth <= 750){
      this.phoneApp = true;
    }
  }

}
